export default "__VITE_ASSET__BHLedqtL__"